module.exports = __webpack_public_path__ + "img/07.85ca2067.png";